import React, { useState, useEffect } from "react";
import { AppConfig } from "../../../app-state";
import { AppLoad } from "../../../core/AppLoad";
import { EventStripItem } from "../../common/event/EventStripItem";
import { Spinner } from "../../../core/Spinner";
import { Icon } from "../../../core/Icon";
import Dropdown from "react-dropdown";
import { ACategoryOptions } from "../../../enums/categoryOptions";
export const PublicEventList = (props) => {
    // const { AppState, updateAppState } = useAppState();
    // const { state, dispatch } = useContext(AppStateContext);
    const [events, setEvents] = useState(null);
    const [eventIdEnrollments, setEventIdEnrollments] = useState(null);
    const [loadState, setLoadState] = useState('firstLoad'); // firstLoad | loading | loaded
    const [category, setCategory] = useState("0");
    const loadEvents = () => {
        AppLoad(AppConfig.APIUrl + 'public/events/list', { category: category, stateFilter: props.stateFilter }).then((Response) => {
            if (Response.status == 'error') {
                //setSubmitErrors(Response.errors)
            }
            else if (Response.status == 'ok') {
                setEvents(Response.data);
                setEventIdEnrollments(Response.eventIdEnrollments);
                setLoadState('loaded');
                // history.push('/cs/proces/registrace/dokonceno');
            }
        });
    };
    useEffect(loadEvents, [category, props.stateFilter]);
    let sectionTitle;
    switch (props.stateFilter) {
        case 'closest':
            sectionTitle = 'Nejbližší aukce';
            break;
        case 'open':
            sectionTitle = 'Probíhající aukce';
            break;
        case 'closed':
            sectionTitle = 'Ukončené aukce';
            break;
        case 'my':
            sectionTitle = 'Moje aukce';
            break;
    }
    const ItemGarde = React.createElement("div", { className: "event-strip-item garde", "aria-hidden": true },
        React.createElement("div", { className: "garde-inner" }));
    return (React.createElement("div", { key: props.stateFilter },
        props.stateFilter == 'closest' &&
            React.createElement("div", { className: "hero" },
                React.createElement("div", { className: "container size-1100" },
                    React.createElement("h1", null,
                        "Elektronick\u00E9 aukce ",
                        AppConfig.companyName),
                    React.createElement("p", { className: "mb-0" }, "Spole\u010Dnost MORAVOLEN HOLDING a.s. nab\u00EDz\u00ED prodej movit\u00E9ho i nemovit\u00E9ho majetku formou elektronick\u00E9 aukce. Elektronick\u00E1 aukce je zp\u016Fsob prodeje, kter\u00FD efektivn\u011B nahrazuj\u00EDce klasick\u00E9 aukce po\u0159\u00E1dan\u00E9 v re\u00E1ln\u00E9m \u010Dase a m\u00EDst\u011B, do kter\u00E9ho se mohou z\u00E1jemci zapojit d\u00EDky informa\u010Dn\u00EDm technologi\u00EDm a internetu nez\u00E1visle na m\u00EDst\u011B, kde se v dan\u00FD okam\u017Eik nach\u00E1z\u00ED, a tedy bez nutnosti cestovat do m\u00EDsta k proveden\u00ED klasick\u00E9 aukce."))),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "flex-space pt-32 pb-32" },
                React.createElement("h2", { className: "mb-0" }, sectionTitle),
                React.createElement(Dropdown, { value: category, onChange: (item) => setCategory(item.value), options: ACategoryOptions.concat([{ value: "0", label: "Všechny kategorie" }]) })),
            loadState == 'firstLoad' ?
                React.createElement(Spinner, { large: true })
                :
                    React.createElement("div", null, (events && events.length > 0) ?
                        React.createElement("div", { className: "event-strip" },
                            events.map((item, index) => {
                                return React.createElement(EventStripItem, { item: item, key: index, stateFilter: props.stateFilter, eventIdEnrollments: eventIdEnrollments });
                            }),
                            events.length < 2 && ItemGarde,
                            events.length < 3 && ItemGarde)
                        :
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "message-block" },
                                    React.createElement("div", { className: "" },
                                        React.createElement(Icon, { c: ['empty', 48, 48] }),
                                        React.createElement("div", { className: "message" }, "\u017D\u00E1dn\u00E9 aukce k zobrazen\u00ED"))))))));
};
